export default __webpack_public_path__ + "static/cart-reduce-8731b88c841e2c2272f7f760fdaccc4e.png";